module.exports = __webpack_public_path__ + "static/img/CEE3.ab7fb31d.jpg";